
import Vue from "vue";
import { Component } from "vue-property-decorator";
import { globalStore, uiStore } from "@/store/store";
import defensiveCopy from "@/util/defensive-copy";
import { CSSSelector } from "@/types/selectors";
import SelectorsList from "./SelectorsList.vue";
import AddSelector from "./AddSelector.vue";
import PanelHeader from "@/components/Reusable/Util/PanelHeader.vue";

// @ts-ignore
import draggable from "vuedraggable";
import BrowseModeToggle from "@/components/BrowseMode/BrowseModeToggle.vue";
import PanelHeaderButton from "@/components/Reusable/Util/PanelHeaderButton.vue";
import SelectorsPanelHistoryViewMode from "@/components/Settings/Selectors/SelectorsPanelHistoryViewMode.vue";
import AlertBox from "@/components/Reusable/CustomInputs/AlertBox.vue";
import FreeModeAlertForSelectors from "@/components/Subscription/FreeModeAlertForSelectors.vue";

@Component({
  components: {
    FreeModeAlertForSelectors,
    AlertBox,
    SelectorsPanelHistoryViewMode,
    PanelHeaderButton,
    BrowseModeToggle,
    draggable,
    SelectorsList,
    AddSelector,
    PanelHeader
  }
})
export default class ManageSelectors extends Vue {
  get viewMode() {
    return uiStore.panelState.selectorsPanelPanelActiveViewMode;
  }
  toggleViewMode() {
    uiStore.setPanelState({
      ...uiStore.panelState,
      selectorsPanelPanelActiveViewMode:
        this.viewMode === "controls" ? "history" : "controls"
    });
  }

  get selectors() {
    return globalStore.cssSelectors;
  }

  updateSelectors(newSelectors: CSSSelector[]) {
    globalStore.setSelectors(defensiveCopy(newSelectors));
  }
}
